import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container footer-content">
                <div className="footer-links">
                    <Link to="/privacy">Politique de confidentialité</Link>
                    <Link to="/terms">Conditions d'utilisation</Link>
                </div>
                <div className="copyright">
                    <p>&copy; {currentYear} Jeledi. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
